(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    class CardGalleryDots {
    constructor(gallery) {
      this.gallery = gallery;
      this.dots = gallery.querySelectorAll('.card-gallery-dot');
      this.slideshow = gallery.querySelector('slideshow-component');
      if (!this.dots.length || !this.slideshow) return;
      this.scroller = this.slideshow.querySelector('slideshow-slides');
      if (!this.scroller) return;

      this.dots.forEach(dot => {
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const idx = parseInt(dot.dataset.slideIndex);
          const slides = this.scroller.querySelectorAll('slideshow-slide:not([hidden])');
          if (slides[idx]) {
            slides[idx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          }
        });
      });

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
            const slide = entry.target;
            const allSlides = [...this.scroller.querySelectorAll('slideshow-slide:not([hidden])')];
            const idx = allSlides.indexOf(slide);
            if (idx >= 0) this.setActive(idx);
          }
        });
      }, { root: this.scroller, threshold: 0.5 });

      this.scroller.querySelectorAll('slideshow-slide:not([hidden])').forEach(s => this.observer.observe(s));
    }

    setActive(idx) {
      this.dots.forEach((d, i) => d.classList.toggle('active', i === idx));
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.card-gallery').forEach(g => new CardGalleryDots(g));
  });
  } catch(e) { console.error(e); }
})();

})();
